var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramAppreciation48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Small./Appreciation48*",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Heart",
    transform: "translate(9.000000, 5.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0037729,35.2875585 L15.5732893,34.8332072 C15.8873386,34.5776389 16.0810626,34.4191271 16.3946097,34.1596216 C16.8647768,33.7704905 17.3594014,33.3552618 17.87754,32.9129763 C19.2788151,31.7168415 20.6556095,30.4910892 21.9422042,29.2765943 C22.7104662,28.5513852 23.427514,27.8477848 24.0840427,27.1719232 C25.9542655,25.2466276 27.2672523,23.6141607 27.8699762,22.4023775 C28.7991918,20.5489929 28.6974938,18.4689405 27.5858599,16.6511621 C26.2464423,14.4726094 23.6000307,13 21.0308914,13 C18.8467445,13 17.0308894,13.9864025 15.5550361,15.6103653 L15,16.2211022 L14.4449639,15.6103653 C12.9691106,13.9864025 11.1532555,13 8.96910862,13 C6.39996932,13 3.7535577,14.4726094 2.41507588,16.649636 C1.30250617,18.4689405 1.20080819,20.5489929 2.13109096,22.4045145 C3.0078159,24.1671923 5.34444317,26.7633719 8.61721522,29.7981742 C9.82235232,30.9156833 11.0874039,32.0302697 12.3483538,33.0993968 C13.1931047,33.8156395 13.9356799,34.4265204 14.438833,34.8295806 L14.4422414,34.8323273 L15.0037729,35.2875585 Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2501945,7.1113739 L27.0891283,2.50023658",
    id: "Right",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25,0.5 L15.25,5.75",
    id: "Centre",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83973655,7.11046887 L3,2.5",
    id: "Left",
    strokeLinecap: "square",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramAppreciation48);
export default __webpack_public_path__ + "static/media/pictogramAppreciation48.a12cb17a8710a7d72644330a7b4812b2.svg";
export { ForwardRef as ReactComponent };